import {  Container } from "@material-ui/core";
import React from "react";
import TextField from '@material-ui/core/TextField';

function SearchList({ handleChange, searchTerm }) {
  return (
    <Container >
      <TextField
        id="standard-full-width"
        placeholder="Search by supplier name or invoice number"
        fullWidth
        margin="normal"
        InputLabelProps={{
          shrink: true,
        }}
        value={searchTerm}
        onChange={handleChange}
      />
    </Container>
  );
}

export default SearchList;
